if (document.body.classList.contains('blog')) {
    document.body.addEventListener('htmx:afterSwap', function(event) {
        if (event.target.classList.contains('loop-post')) {
            let newPostButtons = event.target.querySelectorAll('.post-link-paginated');
            newPostButtons?.forEach((btn) => {
                btn.addEventListener('mousedown', (e) => {
                    let newPostPage = btn.getAttribute('data-pagination');
                    let currentUrl = new URL(location);
                    let cleanedUrl = currentUrl.href.replace(/page\/\d*\//, '');
                    let newUrl = `${cleanedUrl}page/${newPostPage}/`;
                    history.pushState({}, "", newUrl);
                });
            });
        };
    });
}